module.exports = __webpack_public_path__ + "static/media/wild-in-art.0cd71313.png";